import { render } from "./ProgramUpdate.vue?vue&type=template&id=18e88a5e"
import script from "./ProgramUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__